var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container padding-menu-footer"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('privacy.title')))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('privacy.content'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }